var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_59610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4568 16.1262L13.9784 2.40465C13.4301 1.51632 12.5038 0.986328 11.501 0.986328C10.4988 0.986328 9.57193 1.51682 9.02258 2.40465L0.543246 16.1262C-0.0613896 17.1047 -0.108897 18.3023 0.417258 19.3309C0.942901 20.3586 1.91622 20.9726 3.02168 20.9726H19.9795C21.0845 20.9726 22.0584 20.3586 22.5845 19.3304C23.1096 18.3016 23.0621 17.1041 22.4575 16.1262H22.4568ZM11.5 17.0566C11.0915 17.0566 10.7595 16.7058 10.7595 16.2731C10.7595 15.841 11.091 15.4897 11.5 15.4897C11.9084 15.4897 12.2404 15.8404 12.2404 16.2731C12.2404 16.7058 11.9084 17.0566 11.5 17.0566ZM12.2404 13.9234C12.2404 14.3567 11.9089 14.7069 11.5 14.7069C11.0915 14.7069 10.7595 14.3567 10.7595 13.9234V8.44106C10.7595 8.00781 11.091 7.65762 11.5 7.65762C11.9084 7.65762 12.2404 8.00781 12.2404 8.44106V13.9234Z",
    fill: "#FFC61B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_59610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.737693b263e08b9cbc7b579bc846c551.svg";
export { ForwardRef as ReactComponent };